/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createLOG2E } from '../../factoriesAny.js';
export var LOG2EDependencies = {
  BigNumberDependencies,
  createLOG2E
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLOG2E.generated.js
// module id = dWHP
// module chunks = 3